import React from 'react';
import StatusScreen from '../shared/StatusScreen';
import publicApi from '../../utils/publicApi';
import { isPublicArticle } from '../../utils/articleVisibility';
import { getArticleTypeLabel } from '../../utils/articleType';

class NotFound extends React.Component {
    constructor(props) {
        super(props);
        this.state = { suggestions: [], loading: true };
    }

    componentDidMount() {
        if (typeof window.resetScript === 'function') {
            window.resetScript();
        }
        this.loadSuggestions();
    }

    loadSuggestions = async () => {
        try {
            const response = await publicApi.get('/api/articles?limit=12');
            const articles = response?.data?.articles || [];
            const suggestions = articles
                .filter(isPublicArticle)
                .sort((a, b) => {
                    const dateA = new Date(a.publishedAt || a.createdAt || 0).getTime();
                    const dateB = new Date(b.publishedAt || b.createdAt || 0).getTime();
                    return dateB - dateA;
                })
                .slice(0, 3)
                .map((item) => ({
                    to: `/article/${item.slug}`,
                    type: getArticleTypeLabel(item.type),
                    title: item.title,
                    excerpt: item.excerpt
                }));

            this.setState({ suggestions, loading: false });
        } catch (error) {
            console.error('Error loading suggestions:', error);
            this.setState({ loading: false });
        }
    };

    render() {
        const { suggestions } = this.state;

        return (
            <StatusScreen
                seo={{
                    title: "Page non trouvée — 404",
                    description: "La page que vous recherchez n'existe pas ou a été déplacée."
                }}
                kicker="Erreur 404"
                title={<>Cette page<br />n'existe <em>pas</em>.</>}
                lead="Le lien est mort, ou cette page n'a jamais existé. Le reste du portfolio, lui, est bien là."
                primary={{ to: "/", label: "Retour à l'accueil" }}
                suggestionsTitle="Pendant que vous êtes là"
                suggestions={suggestions}
            />
        );
    }
}

export default NotFound;
